import React from 'react';
import { Icon } from 'elements';

const Document = ({size, className}) => (
  <Icon size={size} className={className}>
    <g transform="translate(2.000000, 4.000000)">
      <path d="M6.979,13.881h-4.89c-0.267,0-0.484,0.16-0.484,0.357c0,0.197,0.217,0.357,0.484,0.357h4.889
        c0.267,0,0.484-0.16,0.484-0.357C7.463,14.041,7.246,13.881,6.979,13.881z"/>
      <path d="M15.033,13.881h-4.889c-0.267,0-0.484,0.16-0.484,0.357c0,0.197,0.217,0.357,0.484,0.357h4.889
        c0.267,0,0.484-0.16,0.484-0.357C15.517,14.041,15.301,13.881,15.033,13.881z"/>
      <path d="M15.006,1.733H2.117c-0.282,0-0.511,0.16-0.511,0.357s0.229,0.357,0.511,0.357h12.889c0.282,0,0.511-0.16,0.511-0.357
        C15.517,1.893,15.288,1.733,15.006,1.733z"/>
      <path d="M15.033,4.592h-4.889c-0.267,0-0.484,0.16-0.484,0.357s0.217,0.357,0.484,0.357h4.889c0.267,0,0.484-0.16,0.484-0.357
        S15.301,4.592,15.033,4.592z"/>
      <path d="M15.033,6.735h-4.889c-0.267,0-0.484,0.16-0.484,0.357s0.217,0.357,0.484,0.357h4.889c0.267,0,0.484-0.16,0.484-0.357
        S15.301,6.735,15.033,6.735z"/>
      <path d="M15.033,9.594h-4.889c-0.267,0-0.484,0.16-0.484,0.357c0,0.197,0.217,0.357,0.484,0.357h4.889
        c0.267,0,0.484-0.16,0.484-0.357S15.301,9.594,15.033,9.594z"/>
      <path d="M15.033,11.737h-4.889c-0.267,0-0.484,0.16-0.484,0.357c0,0.197,0.217,0.357,0.484,0.357h4.889
        c0.267,0,0.484-0.16,0.484-0.357S15.301,11.737,15.033,11.737z"/>
      <path d="M6.979,11.737h-4.89c-0.267,0-0.484,0.16-0.484,0.357c0,0.197,0.217,0.357,0.484,0.357h4.889
        c0.267,0,0.484-0.16,0.484-0.357C7.463,11.897,7.246,11.737,6.979,11.737z"/>
      <path d="M6.979,4.592h-4.89c-0.267,0-0.484,0.212-0.484,0.472v4.772c0,0.261,0.217,0.472,0.484,0.472h4.889
        c0.267,0,0.484-0.212,0.484-0.472V5.064C7.463,4.803,7.246,4.592,6.979,4.592z M6.495,9.363H2.574V5.537h3.921V9.363z"/>
      <path d="M20.348,1.349h-1.541v-1.484c0-0.546-0.461-0.989-1.027-0.989H-0.296c-0.566,0-1.027,0.444-1.027,0.989v15.831
        c0,1.364,1.152,2.474,2.568,2.474h17.563c1.416,0,2.568-1.11,2.568-2.474V2.338C21.375,1.792,20.914,1.349,20.348,1.349z
        M20.348,15.695c0,0.818-0.691,1.484-1.541,1.484H1.244c-0.85,0-1.541-0.666-1.541-1.484V-0.136H17.78v15.089
        c0,0.682,0.576,1.237,1.284,1.237c0.284,0,0.514-0.221,0.514-0.495s-0.23-0.495-0.514-0.495c-0.142,0-0.257-0.111-0.257-0.247
        V2.338h1.541C20.348,2.338,20.348,15.695,20.348,15.695z"/>
    </g>
  </Icon>
);

export default Document;



// WEBPACK FOOTER //
// ./src/core/icons/components/News.jsx